import { IFabricationContractState } from '../../../store/ducks/fabrication-contracts/types';
import { IFabricationProjectsState } from '../../../store/ducks/fabrication-projects/types';
import {
  EProvideWireQuantityTypes,
  IConstructionIdentificationState,
  IDetailingProjectState,
  IExtraItensState
} from '../../../store/ducks/fabrication-purchase-order/types';
import {
  IAnnealedWireTypesState,
  IPieceTypesState,
  ISteelTypesState
} from '../../../store/ducks/fabrication/types';
import { projectPavementsNeedRange } from '../../../utils/fabricationHelper';

export const isAllFieldsValidInConstructionIdentification = (
  constructionIdentificationState: IConstructionIdentificationState,
  contractsState: IFabricationContractState
): boolean => {
  const selectedContract = contractsState.contracts?.find(
    (contr) =>
      contr.contractNumber === constructionIdentificationState.contractNumber
  );

  const { contractNumber, desiredDate, orderNumber } =
    constructionIdentificationState;

  return (
    !contractsState.loading &&
    !contractsState.error &&
    !!selectedContract &&
    !selectedContract.errorDetails &&
    !!contractsState.contracts &&
    !!contractNumber &&
    !!desiredDate &&
    !!orderNumber &&
    orderNumber.length >= 3 &&
    !!selectedContract.lastOrderDetails &&
    !selectedContract.lastOrderDetails.some(
      (order) => order.orderNumber === orderNumber
    )
  );
};

export const isAllFieldsValidInDetailingProject = (
  detailingProjectState: IDetailingProjectState,
  fabricationProjectsState: IFabricationProjectsState
): boolean => {
  const getSelectedProject = (projectId: number) => {
    return fabricationProjectsState.projects?.find((p) => p.id === projectId);
  };
  return (
    !fabricationProjectsState.loading &&
    detailingProjectState.vehiclesTypes !== undefined &&
    detailingProjectState.vehiclesTypes.length > 0 &&
    !detailingProjectState.itens.some((item) => {
      if (!item.projectId) {
        return false;
      }

      const selectedProject = getSelectedProject(item.projectId);
      const pavementRangeNeeded =
        selectedProject &&
        projectPavementsNeedRange(
          selectedProject.structures.map((s) => s.name)
        );
      return (
        !fabricationProjectsState.projects?.find(
          (p) => p.id === item.projectId
        ) ||
        (!!selectedProject?.mockupId &&
          pavementRangeNeeded &&
          item.pavements.length < 2) ||
        (!!selectedProject?.mockupId && item.pavement.length < 1) ||
        !item.revision ||
        !item.pavement ||
        !item.amount ||
        (!item.completeDrawing && !item.observation)
      );
    })
  );
};

export const isAllFieldsValidInExtraItens = (
  hasAnyProjectSelected: boolean,
  extraItensState: IExtraItensState,
  pieceTypesState?: IPieceTypesState,
  steelTypesState?: ISteelTypesState,
  annealedWireTypesState?: IAnnealedWireTypesState
): boolean => {
  const isValidExtraItensFields = (): boolean => {
    if (
      (extraItensState.otherPieces.some(
        (piece) => piece.pieceTypeId !== undefined
      ) &&
        (!pieceTypesState || !steelTypesState)) ||
      (extraItensState.annealedWires.some(
        (wire) => wire.annealedWireTypeId !== undefined
      ) &&
        !annealedWireTypesState)
    ) {
      return false;
    }

    const hasSomeDiemetersLoading =
      steelTypesState &&
      (steelTypesState.steelTypes.some(
        (st) => st.diametersState && st.diametersState.loading
      ) ||
        false);

    const hasAnyAnnealedWireSelected =
      extraItensState.annealedWires.filter(
        (wire) => wire.annealedWireTypeId !== undefined
      ).length > 0;

    return !extraItensState.otherPieces.some((item) => {
      if (
        !item.pieceTypeId &&
        !item.steelTypeId &&
        (hasAnyAnnealedWireSelected || hasAnyProjectSelected)
      )
        return false;

      const pieceType = pieceTypesState?.pieceTypes.find(
        (st) => st.id === item.pieceTypeId
      );
      return (
        !item.pieceTypeId ||
        !item.steelTypeId ||
        !item.diameterId ||
        (pieceType?.measureA && !item.measureA) ||
        (pieceType?.measureB && !item.measureB) ||
        (pieceType?.measureC && !item.measureC) ||
        !item.amount ||
        item.weight === undefined ||
        pieceTypesState?.loading ||
        hasSomeDiemetersLoading ||
        steelTypesState?.loading
      );
    });
  };

  const isValidWireItensFields = (): boolean => {
    const hasAnyExtraItemSelected =
      extraItensState.otherPieces.filter(
        (item) => item.pieceTypeId !== undefined
      ).length > 0;
    return !extraItensState.annealedWires.some((item) => {
      if (
        !item.annealedWireTypeId &&
        (hasAnyExtraItemSelected || hasAnyProjectSelected)
      )
        return false;

      return (
        !item.annealedWireTypeId ||
        (item.provideQuantityBy === EProvideWireQuantityTypes.PERCENTAGE &&
          !item.percentage) ||
        (item.provideQuantityBy === EProvideWireQuantityTypes.WEIGHT &&
          !item.weight) ||
        annealedWireTypesState?.loading
      );
    });
  };

  return isValidExtraItensFields() && isValidWireItensFields();
};
